import React from 'react'
import className from 'classnames/bind'

import style from './Error.module.scss'

import SvgExceptionHeaderBack from '@Root/ui/images/myhouse/exception_header--back.svg'
import BlindContent from '@Components/VAC/common/BlindContent'
import innerHtml from '@Root/utils/innerHtml'

type Props = {
  header?: any
  error?: any
  maintenance?: any
}

const cx = className.bind(style)

const Exception: React.FC<Props> = ({ header, error, maintenance }: Props) => {
  return (
    <div className={cx('article')}>
      {header && (
        <header className={cx('header')}>
          <a onClick={header.handleClick} className={cx('link_back')}>
            <SvgExceptionHeaderBack />
            {header.button}
          </a>

          <h1 className={cx('title')}>{header.title}</h1>
        </header>
      )}

      <BlindContent />

      <section id="content" className={cx('inner')} role="main">
        <div className={cx('exception')}>
          {error?.title && <strong className={cx('title')} {...innerHtml(error?.title)}></strong>}
          {error?.description && <p className={cx('text')} {...innerHtml(error?.description)}></p>}
          {maintenance?.period && <em className={cx('emphasis')} {...innerHtml(maintenance?.period)}></em>}
          {maintenance?.description && <p className={cx('text')} {...innerHtml(maintenance?.description)}></p>}
          {error?.button && (
            <button type="button" className={cx('button_exception')} onClick={error.handleClick}>
              {error.button}
            </button>
          )}
        </div>
      </section>
    </div>
  )
}

export default Exception
